import { history, useIntl } from 'umi';
import { useState } from 'react';
import { IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import dayjs from 'dayjs';
import { optionToKey } from '@/utils/comUtil.js';
import { sexMap } from '@/constants.js';
import AddMember from '../../add/components/add_member/AddMember';
import DataTableNativeML from '@/components/DataTableNativeML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import styles from './TablePage.less?modules';
import { fmtThousand } from '@/utils/comUtil';

const TablePage = (props) => {
  //用于国际化的方法
  const intl = useIntl();
  const { formatMessage } = intl;
  const theme = useTheme();
  const { pathname } = history.location;
  //新增按钮弹框
  const [modalVisible, setVisible] = useState(false);
  // 新增弹出
  const handleOk = () => {
    setVisible(false);
  };
  // 新增弹入
  const handleCancel = () => {
    setVisible(false);
  };
  const {
    pagination,
    total,
    loading,
    setColumn,
    setSort,
    tableData,
    hasNext,
    allTotal,
    setPageData,
  } = props || {};
  const handleMemberDetail = (record, status) => {
    const { name, gender, level, mobile, memberCode } = record;

    history.push({
      pathname:
        pathname === '/dealer-customer/mm'
          ? '/dealer-customer/mm/ml'
          : '/cm/mm/ml',
      query: {
        id: String(record.id),
        status: status,
        tab: 0,
        name,
        gender,
        level,
        mobile,
        memberCode,
        sourceOid: status
          ? 'btn_offline_store_customer_management_list_details'
          : 'link_offline_store_customer_management_list_details',
      },
    });
  };

  const columns = [
    {
      align: 'center',
      title: formatMessage({ id: 'cm.member.c01.lbl01' }),
      id: 'memberCode',
      event: {
        onClick: (value, row) => {
          handleMemberDetail(row);
        },
      },
      tdCellStyle: {
        color: 'rgb(21,101,192)',
      },
      width: 180,
      render: ({ memberCode, id }) => {
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        return (
          <div
            data-log={JSON.stringify({
              oid: 'link_offline_store_customer_management_list_details',
              events: ['_ev', '_ec'],
              params: {
                member_id: id,
              },
            })}
            className={styles.hover}
          >
            {memberCode}
          </div>
        );
      },
    },
    {
      title: formatMessage({ id: 'cm.member.c01.lbl02' }),
      align: 'center',
      id: 'name',
      key: 'name',
      width: 120,
    },
    {
      title: formatMessage({ id: 'cm.member.c01.lbl03' }),
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      width: 140,
    },
    {
      title: formatMessage({ id: 'cm.member.c01.lbl04' }),
      id: 'gender',
      key: 'gender',
      width: 100,
      align: 'center',
      render: (text) => {
        let sex = '';
        sex = optionToKey(sexMap, text.gender);
        return sex;
      },
    },
    {
      title: formatMessage({ id: 'cm.member.c01.lbl05' }),
      id: 'level',
      key: 'level',
      align: 'center',
      width: 180,
      // sort: {
      //   order,
      //   setOrder,
      //   orderBy,
      //   setOrderBy,
      //   sortChange: (id, sort) => {
      //     setOrderObj({ ...orderObj, level: sort });
      //     setColumn('LEVEL');
      //     setSort(sort);
      //     setOrderBy(id);
      //     // setOrder(sort);
      //   },
      // },
      // sortDirections: ['ascend', 'descend', 'default'],
      // sorter: (a, b, c) => {
      //   setColumn('GRADE');
      //   setSort(c);
      //   return false;
      // },
    },
    {
      title: 'VIP',
      id: 'hasVip',
      key: 'hasVip',
      align: 'center',
      width: 100,
      render: (text) => {
        return text.hasVip ? '是' : '否';
      },
    },
    {
      title: 'VIP到期时间',
      id: 'expireDate',
      key: 'expireDate',
      align: 'center',
      width: 140,
    },
    {
      title: '累计积分',
      id: 'historyPoint',
      key: 'historyPoint',
      align: 'right',
      width: 140,
      render: (item) => {
        return (
          <span textAlign="center">
            {typeof item.historyPoint === 'number'
              ? fmtThousand(item.historyPoint, 0)
              : ''}
          </span>
        );
      },
    },
    {
      title: formatMessage({ id: 'cm.member.c01.lbl06' }),
      id: 'availablePoint',
      key: 'availablePoint',
      width: 140,
      align: 'right',
      sortDirections: ['ascend', 'descend', 'default'],
      render: (item) => {
        return (
          <span textAlign="center">
            {typeof item.availablePoint === 'number'
              ? fmtThousand(item.availablePoint, 0)
              : ''}
          </span>
        );
      },
    },
    // {
    //   title: formatMessage({ id: 'cm.member.c01.lbl07' }),
    //   id: 'channel',
    //   key: 'channel',
    //   width: 120,
    //   align: 'center',
    //   render: ({ channel: text }) => {
    //     let grade = '';
    //     grade = optionToKey({ ...channelMap, STOREWIFI: '门店WIFI' }, text);
    //     return grade;
    //   },
    // },
    {
      title: formatMessage({ id: 'cm.member.c01.lbl08' }),
      id: 'signUpDate',
      key: 'signUpDate',
      width: 140,
      align: 'center',
      sortDirections: ['ascend', 'descend', 'default'],
      sorter: (a, b, c) => {
        setColumn('SIGN_UP_DATE');
        setSort(c);
        return false;
      },

      render: ({ signUpDate: text }) => (
        <div>{dayjs(text).format('YYYY-MM-DD')}</div>
      ),
    },
    // {
    //   title: formatMessage({ id: 'cm.member.c01.lbl09' }),
    //   id: 'registerStoreName',
    //   key: 'registerStoreName',
    //   width: 180,
    //   align: 'center',
    // },
    // {
    //   title: formatMessage({ id: 'cm.member.c01.lbl10' }),
    //   id: 'mangeStoreName',
    //   key: 'mangeStoreName',
    //   width: 180,
    //   align: 'center',
    // },
    {
      title: formatMessage({ id: 'cm.member.c01.lbl11' }),
      width: 140,
      align: 'center',
      render: (recor) => {
        return (
          <div align="center" className={styles.handle_btn}>
            <ButtonTip title="详情">
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                className=""
                data-log={JSON.stringify({
                  oid: 'btn_offline_store_customer_management_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    member_id: recor.id,
                  },
                })}
                onClick={() => handleMemberDetail(recor, 'detail')}
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={theme.palette.primary.main}
                  // fill={'#1B60AD'}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];
  const headerTip = (
    <div className="number-wrapper">
      <div className="number">
        <span className="text">
          {formatMessage({ id: 'cm.member.c01.1bl12' })}
        </span>
        <span> {fmtThousand(allTotal, 0)}</span>
      </div>
    </div>
  );
  return (
    <>
      <DataTableNativeML
        loading={loading}
        paging={true}
        total={total}
        hasNext={hasNext}
        initP={true}
        columns={columns}
        headerTip={headerTip}
        page={pagination}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={tableData}
        columnKey="id"
      ></DataTableNativeML>
      <AddMember
        handleOk={handleOk}
        handleCancel={handleCancel}
        open={modalVisible}
        onClose={handleCancel}
      />
    </>
  );
};
export default TablePage;
